import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../../../config/URL";
import toast from "react-hot-toast";
import ImageURL from "../../../config/ImageURL";

function CampaignView() {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadIndicator, setLoadIndicator] = useState(false);

  const getData = async () => {
    setLoading(true);
    try {
      const response = await api.get(`admin/campaign/${id}`);
      setData(response.data.data);
    } catch (error) {
      toast.error("Error Fetching Data ", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, [id]);

  const config = data?.campaign_config?.[0] || {};
  const {
    show_name,
    show_email,
    show_phone,
    show_address,
    custom_select_required,
    custom_select_label,
    custom_select_options,
  } = config;

  const fields = [];
  if (show_name) fields.push("Name");
  if (show_email) fields.push("Email");
  if (show_phone) fields.push("Phone");
  if (show_address) fields.push("Address");
  if (custom_select_required) fields.push("Custom Field");

  let parsedOptions = [];
  try {
    parsedOptions = custom_select_options ? JSON.parse(custom_select_options) : [];
  } catch (e) {
    parsedOptions = [];
  }

  const handleToggleStatus = async () => {
    setLoadIndicator(true);
    try {
      const res = await api.post(`admin/campaign/status/${id}`);
      const { success, message } = res.data || {};
      if (success) {
        toast.success(message);
        setData((prev) => ({
          ...prev,
          is_active:
            prev.is_active === 1 || prev.is_active === "1" ? 0 : 1,
        }));
      } else {
        toast.error(message);
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
    setLoadIndicator(false);
  };

  return (
    <section className="px-4">
      {loading ? (
        <div className="loader-container">
          <div className="loader">
            <svg viewBox="0 0 80 80">
              <circle cx="40" cy="40" r="32"></circle>
            </svg>
          </div>
        </div>
      ) : (
        <>
          <div className="card shadow border-0 mb-3">
            <div className="row p-3">
              <div className="d-flex justify-content-between align-items-center w-100">
                <div>
                  <h3 className="ls-tight">Campaign</h3>
                </div>
                <div className="d-flex gap-3">
                  <div>
                    <Link to="/campaign">
                      <button type="button" className="btn btn-light btn-sm">
                        <span>Back</span>
                      </button>
                    </Link>
                  </div>
                  <div>
                    <button
                      type="button"
                      onClick={handleToggleStatus}
                      className={`btn btn-sm me-2 ${data.is_active === 1 || data.is_active === "1" ? "btn-danger" : "btn-success"}`}
                      disabled={loadIndicator}
                    >
                      {loadIndicator && (
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          aria-hidden="true"
                        ></span>
                      )}
                      {data.is_active === 1 || data.is_active === "1" ? "Deactivate" : "Activate"}
                    </button>
                  </div>
                  <div>
                    <Link to={`/campaign/edit/${data.id}`}>
                      <button type="button" className="btn btn-light btn-sm">
                        <span>Edit</span>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container card shadow border-0" style={{ minHeight: "80vh" }}>
            <div className="row mt-5 p-3">
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Title</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {data.title}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Web URL</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {data.web_url || "--"}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Description</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {data.description || "--"}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Display Fields</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {fields.length > 0 ? fields.join(", ") : "--"}</p>
                  </div>
                </div>
              </div>
              {custom_select_required === 1 && (
                <>
                  <div className="col-md-6 col-12">
                    <div className="row mb-3">
                      <div className="col-6 d-flex justify-content-start align-items-center">
                        <p className="text-sm">Custom Label</p>
                      </div>
                      <div className="col-6">
                        <p className="text-muted text-sm">: {custom_select_label || "--"}</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="row mb-3">
                      <div className="col-6 d-flex justify-content-start align-items-center">
                        <p className="text-sm">Custom Options</p>
                      </div>
                      <div className="col-6">
                        <p className="text-muted text-sm">: {parsedOptions.length > 0 ? parsedOptions.join(", ") : "--"}</p>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Image</p>
                  </div>
                  <div className="col-12">
                    {data.image && (
                      <img
                        src={`${ImageURL}${data.image}`}
                        alt={data.title}
                        className="img-fluid"
                        style={{ maxHeight: "100px" }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  );
}

export default CampaignView;